module.exports = __webpack_public_path__ + "frontend/images/white/carousel/traveling@2.png?4c88240cb409277aaf0a03b7e59d47b7";